import usePermissions from "hooks/usePermissions";
const REQUIRED_INVESTIGATION_PERMISSIONS = ["investigations:create", "investigations:edit"].map(
  (perm) => perm
);
const REQUIRED_STREAM_PERMISSIONS = ["streams:read"];
export const ALL_EVENTS_STREAM_ID = "000000000000000000000002";
const useCanUseAutoCreateInvestigation = () => {
  const { isPermitted, isAnyPermitted } = usePermissions();
  return isPermitted(REQUIRED_INVESTIGATION_PERMISSIONS) && isAnyPermitted([...REQUIRED_STREAM_PERMISSIONS, `streams:read:${ALL_EVENTS_STREAM_ID}`]);
};
export default useCanUseAutoCreateInvestigation;
